import React, { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AppSidebar } from "@/components/AppSidebar";
import { useAuth } from "@/contexts/AuthContext";
import { Logo } from "@/components/Logo";
import { Menu } from "lucide-react";

export function AppLayout() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#05073B]">
        <div className="text-sm text-slate-400">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return (
    <div className="dark flex min-h-screen bg-[#03040B] text-slate-100 lg:h-screen">
      <AppSidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Mobile top bar */}
        <header
          className="flex items-center justify-between border-b border-slate-800 bg-[#05073B] px-4 py-3 lg:hidden"
          data-testid="app-mobile-header"
        >
          <button
            type="button"
            onClick={() => setMobileOpen(true)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-slate-200 hover:bg-slate-800 hover:text-white"
            aria-label="Open menu"
            data-testid="app-mobile-menu-btn"
          >
            <Menu className="h-5 w-5" />
          </button>
          <Logo size="sm" inverted />
          <div className="h-10 w-10" aria-hidden />
        </header>

        <main className="flex-1 overflow-y-auto" data-testid="app-main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
